<template>

  <div class="main">

    <!-- ToolBar -->
    <div class="mb-4 pb-4">
      <v-toolbar fixed light dense color="white">
        <v-btn active-class icon light to="/tkbios">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <vue-letter-avatar :name="profileinfo.tkname" size="35" :rounded="true" />
        <v-toolbar-title class="tk-name-toolbar header pa-2 ma-0" v-text="profileinfo.tkname"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn active-class icon to="/tkbios">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <!-- <v-icon slot="activator" color="black" dark>fa fa-paw</v-icon> -->
            <v-icon slot="activator" color="black" dark>fas fa-cat</v-icon>
            <span>Back to All TK Cat Bios</span>
          </v-tooltip>
        </v-btn>
        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="30px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>Back to Home</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat round icon :href="facebook" target="_blank">
          <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" medium>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>
      </v-toolbar>
    </div>

    <v-container grid-list-lg fluid class="ma-0 pa-3">

      <v-layout wrap justify-center>
        <!-- Bio Profile Pict -->
        <v-flex xs12 class="pa-0 mb-2" elevation-4>
          <v-card max-height="100%">
            <v-img max-height="100%" class="mb-0 bio-profile-pict" :src="require(`@/img/${profileinfo.profilepict}`)">
              <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                <v-progress-circular size="60" :width="8" indeterminate color="blue lighten-1"></v-progress-circular>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>

        <!-- Bio Profile Details -->
        <v-flex xs12 class="pa-0 mb-1" elevation-4>
          <v-card max-height="100%" class="pb-2 bio-border">
            <v-flex xs12>
              <v-card-title><h2 class="black--text tk-bio-name mx-auto">{{ profileinfo.tkname }}'s Bio</h2></v-card-title>
              <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
              <span class="pl-1"><b>Date of Birth:</b> {{profileinfo.dateofbirth}}</span>
              <div v-if="profileinfo.dateofdeath">
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1"><b>Date of Death:</b> {{profileinfo.dateofdeath}}</span>
              </div>
              <div v-if="profileinfo.locationofbirth">
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1"><b>I Was Born In:</b> {{profileinfo.locationofbirth}}</span>
              </div>
              <div v-if="profileinfo.wherefound">
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1"><b>I Was Found/Rescued:</b> {{profileinfo.wherefound}}</span>
              </div>
              <div v-for="(bioitem, index) in profileinfo.bioinfo" :key="index">
                <div v-if="bioitem">
                  <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                  <span class="pl-1" v-html="bioitem"></span>
                </div>
              </div>
              <div>
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1">See more of me at the links below </span><v-icon color="blue" size=".9rem" class="pt-1">fas fa-ellipsis-h</v-icon>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- Inner Cards that provide links to further details -->
      <v-layout row wrap class="mt-1">
        <v-flex v-for="card in cards" :key="card.title" xs12 sm4 elevation-4 class="pa-1 bio-links">
          <router-link class="rtlnk" :to="{ name: `${card.link}`, params: { tkid: tkid} }">
            <v-card hover ripple height="100%">
              <v-img :src="card.image" height="100%">
                <v-layout fill-height>
                  <v-flex xs12 align-end>
                    <v-icon color="black" class="mt-1 ml-1">{{card.icon}}</v-icon>
                    <span class="headline black--text pl-1" v-text="card.title"></span>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-card>
          </router-link>
        </v-flex>
      </v-layout>

    </v-container>

    <!-- Back to top button. Show on mobile/ipad only -->
    <div class="hidden-md-and-up">
      <v-btn
        id="scrolltotop"
        bottom fab fixed right small dark elevation-24
        color="transparent"
        class="back-to-top"
        style="color: blue;"
        slot="activator"
        v-on:click="scrollToTop"
      ><v-icon medium>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import FooterView from "./FooterView";

export default {
  components: {
    FooterView,
  },
  props: {
    tkid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    facebook: "https://www.facebook.com/timmyskittys1",
    cards: [
      {
        title: "Pictures",
        link: "TkPictGridView",
        image: require("../img/profile_link_tklink.jpg"),
        icon: 'far fa-images'
      },
      {
        title: "Videos",
        link: "TkVideosView",
        image: require("../img/profile_link_videos.jpg"),
        icon: 'fas fa-video'
      },
      {
        title: "Stories",
        link: "TkStoriesView",
        image: require("../img/profile_link_stories.jpg"),
        icon: 'fas fa-pen-fancy'
      },
    ]
  }),
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("scrolltotop").style.display = "block";
      } else {
        document.getElementById("scrolltotop").style.display = "none";
      }
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    ...mapGetters([
      // 'getByName'
      'getById'
    ]),
    profileinfo () {
      return this.getById(this.tkid)
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
};
</script>

<style scoped>
.main {
  background-color: #f8f8ff;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.toolbar {
  background-color: #f8f8ff;
}
.headline {
  font-weight: bold;
  font-size: 2rem;
  /* Note, font not working */
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.profilepict {
  background-size: cover;
  max-width: 100%;
  height: auto;
}
.profilebio {
  color: #000;
}
.biolayout {
  margin-bottom: 60px;
}
.tk-name-toolbar {
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.bio-profile-pict {
  /* margin-right: 5px; */
  /* border: 1px solid rgba(0, 0, 0, .2); */
  border: 2px solid rgb(212, 212, 212);
  border-radius: 2px;
}
.bio-item-info {
  display: inline-block;
  align-items: center;
  vertical-align: auto;
}
.bio-border {
  /* border: 6px solid transparent; */
  /* border-image: url("../img/border_paws_800x747.jpg") 40 round; */
  /* border: 2px solid rgba(0, 0, 0, .2); */
  border: 2px solid rgb(212, 212, 212);
  border-radius: 2px;
}
.bio-links {
  /* border: 2px solid rgba(0, 0, 0, .2); */
  border: 2px solid rgb(212, 212, 212);
  border-radius: 2px;
}
.header {
  text-transform: capitalize;
  font-size: 2rem;
}
.tk-bio-name {
  text-transform: capitalize;
  font-size: 2rem;
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.tk-bio-name::first-letter {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 3.2rem;
  line-height: 0;
  font-weight: bolder;
  color: black;
  margin-right: 3px;
}
.footer {
  margin-top: 10px;
}
/******** iPads (portrait) *********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .footer {
    margin-top: 20px;
  }
}
/********** iPad 3 (landscape) **********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
}
/************ iPad Pro (portrait) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}
/************ iPad Pro (landscape) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}

/************************************** iPhones *************************************/
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* iPhone 6/7/8/X plus ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy III */
@media screen and (device-width: 360px) and (device-height: 640px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.4rem;
  }
}
/* Nexus */
@media screen and (device-width: 600px) and (device-height: 960px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen  and (min-device-width: 1200px) and (max-device-width: 1920px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 2.3rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen and (min-device-width: 800px) and (max-device-width: 1.60px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 2.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TkProfileView.vue